module.exports = __webpack_public_path__ + "img/prb.00666f1c.png";